import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  // Lock body scroll when modal is open
  useEffect(() => {
    if (activeModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [activeModal]);
  return <>
      <footer className="bg-[#050505] py-12 px-4 border-t border-white/5" data-id="element-19">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6 text-sm text-gray-500" data-id="element-20">
          <p data-id="element-21">
            © {new Date().getFullYear()} Tu Primer Ingreso Extra. Todos los
            derechos reservados.
          </p>

          <div className="flex items-center gap-6" data-id="element-22">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-brand-yellow transition-colors" data-id="element-23">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="hover:text-brand-yellow transition-colors" data-id="element-24">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-25">
        {activeModal && <LegalModal type={activeModal} onClose={() => setActiveModal(null)} data-id="element-26" />}
      </AnimatePresence>
    </>;
}
function LegalModal({
  type,
  onClose
}: {
  type: 'privacy' | 'terms';
  onClose: () => void;
}) {
  const content = type === 'privacy' ? privacyContent : termsContent;
  const title = type === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones';
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-8" data-id="element-27">
      {/* Backdrop */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} onClick={onClose} className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-28" />

      {/* Modal Card */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} className="relative w-full max-w-2xl bg-[#111] border border-white/10 rounded-xl shadow-2xl overflow-hidden flex flex-col max-h-[80vh]" data-id="element-29">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-white/10 bg-[#111]" data-id="element-30">
          <h3 className="text-xl font-display font-bold text-white" data-id="element-31">{title}</h3>
          <button onClick={onClose} className="p-2 text-gray-400 hover:text-white hover:bg-white/10 rounded-lg transition-colors" data-id="element-32">
            <X size={20} data-id="element-33" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 md:p-8 overflow-y-auto text-gray-300 space-y-4 text-sm leading-relaxed custom-scrollbar" data-id="element-34">
          {content}
        </div>

        {/* Footer */}
        <div className="p-4 border-t border-white/10 bg-[#111] flex justify-end" data-id="element-35">
          <button onClick={onClose} className="px-6 py-2 bg-white/10 hover:bg-white/20 text-white rounded-lg font-medium transition-colors" data-id="element-36">
            Cerrar
          </button>
        </div>
      </motion.div>
    </div>;
}
const privacyContent = <>
    <p data-id="element-37">
      <strong data-id="element-38">Última actualización: {new Date().toLocaleDateString()}</strong>
    </p>
    <p data-id="element-39">
      En Tu Primer Ingreso Extra, nos tomamos muy en serio su privacidad. Esta
      Política de Privacidad describe cómo recopilamos, usamos y protegemos su
      información personal.
    </p>

    <h4 className="text-white font-bold text-lg mt-6 mb-2" data-id="element-40">
      1. Recopilación de Información
    </h4>
    <p data-id="element-41">
      Recopilamos información que usted nos proporciona directamente cuando
      realiza una compra, se suscribe a nuestro boletín o se comunica con
      nosotros. Esto puede incluir su nombre, dirección de correo electrónico y
      detalles de pago.
    </p>

    <h4 className="text-white font-bold text-lg mt-6 mb-2" data-id="element-42">
      2. Uso de la Información
    </h4>
    <p data-id="element-43">
      Utilizamos su información para procesar transacciones, enviar
      actualizaciones sobre su pedido y mejorar nuestros servicios. No vendemos
      ni compartimos su información personal con terceros con fines comerciales
      sin su consentimiento.
    </p>

    <h4 className="text-white font-bold text-lg mt-6 mb-2" data-id="element-44">
      3. Seguridad de los Datos
    </h4>
    <p data-id="element-45">
      Implementamos medidas de seguridad técnicas y organizativas para proteger
      sus datos personales contra el acceso no autorizado, la pérdida o la
      alteración.
    </p>

    <h4 className="text-white font-bold text-lg mt-6 mb-2" data-id="element-46">4. Cookies</h4>
    <p data-id="element-47">
      Utilizamos cookies para mejorar su experiencia en nuestro sitio web. Puede
      configurar su navegador para rechazar todas las cookies o para que le
      avise cuando se envíe una cookie.
    </p>
  </>;
const termsContent = <>
    <p data-id="element-48">
      <strong data-id="element-49">Última actualización: {new Date().toLocaleDateString()}</strong>
    </p>
    <p data-id="element-50">
      Por favor, lea estos Términos y Condiciones cuidadosamente antes de
      utilizar nuestro servicio.
    </p>

    <h4 className="text-white font-bold text-lg mt-6 mb-2" data-id="element-51">
      1. Aceptación de los Términos
    </h4>
    <p data-id="element-52">
      Al acceder y utilizar este sitio web, usted acepta estar sujeto a estos
      Términos y Condiciones y a todas las leyes y regulaciones aplicables.
    </p>

    <h4 className="text-white font-bold text-lg mt-6 mb-2" data-id="element-53">
      2. Propiedad Intelectual
    </h4>
    <p data-id="element-54">
      Todo el contenido incluido en este sitio, como texto, gráficos, logotipos,
      imágenes y software, es propiedad de Tu Primer Ingreso Extra o de sus
      proveedores de contenido y está protegido por las leyes de derechos de
      autor.
    </p>

    <h4 className="text-white font-bold text-lg mt-6 mb-2" data-id="element-55">
      3. Licencia de Uso
    </h4>
    <p data-id="element-56">
      Se concede permiso para descargar temporalmente una copia de los
      materiales (información o software) en el sitio web de Tu Primer Ingreso
      Extra solo para visualización transitoria personal y no comercial.
    </p>

    <h4 className="text-white font-bold text-lg mt-6 mb-2" data-id="element-57">
      4. Limitación de Responsabilidad
    </h4>
    <p data-id="element-58">
      En ningún caso Tu Primer Ingreso Extra o sus proveedores serán
      responsables de ningún daño (incluyendo, sin limitación, daños por pérdida
      de datos o beneficios, o debido a la interrupción del negocio) que surja
      del uso o la imposibilidad de usar los materiales en nuestro sitio web.
    </p>

    <h4 className="text-white font-bold text-lg mt-6 mb-2" data-id="element-59">
      5. Modificaciones
    </h4>
    <p data-id="element-60">
      Tu Primer Ingreso Extra puede revisar estos términos de servicio para su
      sitio web en cualquier momento sin previo aviso. Al utilizar este sitio
      web, usted acepta estar sujeto a la versión actual de estos términos de
      servicio.
    </p>
  </>;